import resolveConfig from "tailwindcss/resolveConfig";

import tailwindConfig from "../../tailwind.config";
import { getKeys } from "../utils/object";
import { useWindowSize } from "./use-window-size";

const { theme } = resolveConfig(tailwindConfig);

type Breakpoints = Record<keyof typeof theme.screens, boolean>;

export function useBreakpoints() {
  const { width: windowWidth } = useWindowSize();

  return getKeys(theme.screens).reduce(
    (acc, bpKey) => ({
      ...acc,
      [bpKey]: windowWidth >= parseInt(theme.screens[bpKey]),
    }),
    {}
  ) as Breakpoints;
}
